import React, { useState } from 'react';
import { FiBell, FiInbox, FiCheckCircle, FiSettings, FiArrowLeft, FiChevronDown } from 'react-icons/fi';
import NotificationItem from './NotificationItem';
import './NotificationPanel.css';

// Filas del centro de preferencias. 'push' es el maestro (avisos al dispositivo);
// el resto activa/desactiva push + toast por tipo (siempre quedan en la lista).
const PREF_ROWS = [
  { key: 'push',    label: 'Notificaciones push', desc: 'Avisos en tu dispositivo' },
  { key: 'order',   label: 'Trades y órdenes',    desc: 'Nuevas ofertas y cambios de estado' },
  { key: 'payment', label: 'Pagos',               desc: 'Comprobantes y liberación de fondos' },
  { key: 'message', label: 'Mensajes del chat',   desc: 'Mensajes dentro de tus trades' },
  { key: 'dispute',  label: 'Disputas',           desc: 'Aperturas y resoluciones' },
  { key: 'review',   label: 'Reseñas',            desc: 'Cuando te dejan una calificación' },
  { key: 'security', label: 'Seguridad',          desc: 'Inicios de sesión nuevos y cambios de contraseña' },
  { key: 'follow',   label: 'Nuevos seguidores',  desc: 'Cuando alguien te sigue' },
];

export default function NotificationPanel({
  notifications,
  onClose,
  onNotificationClick,
  onMarkAll,
  onLoadMore,
  hasMore,
  loadingMore,
  prefs = {},
  onTogglePref,
}) {
  const [view, setView] = useState('list');
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <div className="notif-panel" role="dialog" aria-label="Panel de notificaciones">
      {/* Header */}
      <div className="notif-panel-header">
        <div className="notif-panel-header-left">
          {view === 'prefs' ? (
            <button className="notif-panel-iconbtn" onClick={() => setView('list')} aria-label="Volver">
              <FiArrowLeft />
            </button>
          ) : (
            <FiBell className="notif-panel-icon" />
          )}
          <h4 className="notif-panel-title">{view === 'prefs' ? 'Preferencias' : 'Notificaciones'}</h4>
          {view === 'list' && unreadCount > 0 && (
            <span className="notif-panel-badge">{unreadCount} nuevas</span>
          )}
        </div>
        <div className="notif-panel-header-actions">
          {view === 'list' && (
            <button className="notif-panel-iconbtn" onClick={() => setView('prefs')} aria-label="Preferencias" title="Preferencias">
              <FiSettings />
            </button>
          )}
          <button className="notif-panel-close" onClick={onClose} aria-label="Cerrar">×</button>
        </div>
      </div>

      {view === 'prefs' ? (
        <div className="notif-prefs">
          <p className="notif-prefs-intro">Elegí sobre qué querés que te avisemos. Lo que desactives igual queda en esta lista — solo deja de interrumpirte.</p>
          {PREF_ROWS.map(row => {
            const on = prefs[row.key] !== false; // default: activado
            return (
              <button
                key={row.key}
                className="notif-pref-row"
                role="switch"
                aria-checked={on}
                onClick={() => onTogglePref?.(row.key)}
              >
                <span className="notif-pref-text">
                  <span className="notif-pref-label">{row.label}</span>
                  <span className="notif-pref-desc">{row.desc}</span>
                </span>
                <span className={`notif-switch ${on ? 'on' : ''}`}><span className="notif-switch-knob" /></span>
              </button>
            );
          })}
        </div>
      ) : notifications.length === 0 ? (
        <div className="notif-panel-empty">
          <FiInbox className="notif-panel-empty-icon" />
          <p className="notif-panel-empty-text">Sin notificaciones</p>
          <p className="notif-panel-empty-sub">Cuando tengas actividad, aparecerá aquí</p>
        </div>
      ) : (
        <>
          <ul className="notif-panel-list">
            {notifications.map((n, i) => (
              <NotificationItem
                key={n.id ?? i}
                index={i}
                {...n}
                onClick={() => onNotificationClick(n)}
              />
            ))}
          </ul>
          {hasMore && (
            <button className="notif-panel-more" onClick={onLoadMore} disabled={loadingMore}>
              {loadingMore ? 'Cargando...' : <>Ver más <FiChevronDown /></>}
            </button>
          )}
        </>
      )}

      {/* Footer */}
      {view === 'list' && notifications.length > 0 && (
        <div className="notif-panel-footer">
          <button className="notif-panel-mark-all" onClick={onMarkAll} disabled={unreadCount === 0}>
            <FiCheckCircle />
            <span>Marcar todas como leídas</span>
          </button>
        </div>
      )}
    </div>
  );
}
